import controller from './controller';
import template from './template.html';

routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
    $stateProvider
        .state('main.panel.device_add', {
            url: '/device_add',
            controllerAs: 'ctrl',
            controller: controller,
            template:  template
        })
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/device_add/routes.js
 **/